import appReportGenerator from "../../views/appSettings/reportGenerator.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base =
    "reports/generation/report-generator/reports-generation/generator/details/summaries/for-cities";
  const params = ["page", "limit"];

  $stateProvider.state("report-generator", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appReportGenerator,
      },
    },
    reloadOnSearch: false,
    data: { title: "ReportGenerator" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/reportGenerator/reportGenerator.urls.js